class WageTemplate {
    id = 0;
    maritime_object_id = null;
    currency_id = null;
    salary_through_azara = false;
    apply_agency_fee = false;
    fee_type_id = null;
    agency_fee_percentage = null;
    merge_seafarer_salary_and_agency_fee_on_invoice = false;
    full_day_fee = false;
    sick_day_fee = false;
    travel_day_fee = false;
    training_day_fee = false;
    quarantine_day_fee = false;
    standby_day_fee = false;
    other_day_fee = false;
    fixed_fee = false;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default WageTemplate;
